export default __webpack_public_path__ + "static/media/step_006.f89a1b6d.png";